<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <h1 class="text-h2 text-primary">404</h1>
        <p>A Página que está procurando não existe.</p>
        <v-btn variant="outlined" :to="{ name: 'home' }" color="primary">
          Página Inicial
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
// No script needed for this simple component
</script>
